module.exports = __webpack_public_path__ + "static/media/Product_Selector.8a62c7fb.mp4";